export function commaSeparatedNumber(number: number): string {
  return number.toLocaleString();
}
